module.exports = __webpack_public_path__ + "img/headset.93b56aa1.png";